import { liveQuery } from "dexie";
import { useEffect, useState } from "react";

import type { CommerceCalculationRuntimeItem } from "../gateway/local-projection-client";
import { readCommerceCalculationRuntime } from "../local-store/commerce-calculation-runtime";
import type { TerminalCredentialState } from "../local-store/terminal-state";

export function usePosCommerceCalculationRuntime(terminal: TerminalCredentialState | null) {
  const identity = terminal?.identity ?? null;
  const scopeKey = identity
    ? `${identity.organization_id}:${identity.branch_id}:${identity.node_id}`
    : "";
  const [settings, setSettings] = useState<CommerceCalculationRuntimeItem | null>(null);

  useEffect(() => {
    if (!identity || !scopeKey) {
      setSettings(null);
      return;
    }
    const subscription = liveQuery(() => readCommerceCalculationRuntime(identity)).subscribe({
      next: setSettings,
      error: () => setSettings(null),
    });
    return () => subscription.unsubscribe();
  // identity is rehydrated; scopeKey is the stable Local Runtime boundary.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scopeKey]);

  return settings;
}
